<template>
  <header
    v-cloak
    ref="siteHeader"
    class="site-header"
    :class="[
      $store.state.nav.subNavIsOpen ? 'subnav-is-open' : '',
      beforeMount ? 'before-mounted' : '',
    ]"
    data-hook="header"
  >
    <DesktopNav />
    <MobileNav />
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import recommendationStore from '@/stores/recommendation'
import { getQueryFromUrl } from '@/helpers/url'
import { registerStores } from '@/helpers/stores'
import { KEY_ESC } from '@/helpers/keyCodes'
import settings from './navigation-settings'
import DesktopNav from './DesktopNav/DesktopNav.vue'
import MobileNav from './MobileNav/MobileNav.vue'

export default {
  name: 'Navigation',

  components: {
    DesktopNav,
    MobileNav,
  },

  data() {
    return {
      beforeMount: true,
    }
  },

  computed: {
    ...mapState('nav', ['navigationVariant']),
  },

  watch: {
    navigationVariant: {
      immediate: true,
      handler(navigationVariant) {
        this.setNavigationContents(navigationVariant?.identifier)
      },
    },
  },

  beforeCreate() {
    registerStores({ recommendation: recommendationStore })
    const custom_navigation = getQueryFromUrl('custom_navigation')
    if (custom_navigation) {
      this.$store.dispatch('nav/setNavigationVariant', { identifier: custom_navigation })
    } else {
      this.$store.dispatch('nav/fetchNavigationVariant')
    }
  },

  created() {
    this.manageNavState()
    window.addEventListener('resize', () => {
      this.$store.dispatch('nav/toggleSubnav', false)
      this.manageNavState()
    })
  },

  mounted() {
    // Wait for initial line hover animation to finish until making line color non-transparent
    setTimeout(() => {
      this.beforeMount = false
    }, settings.transitionTime)

    document.addEventListener('keydown', this.handleKeydown)
    window.dispatchEvent(new CustomEvent('on:navigation-ready'))
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
  },

  methods: {
    ...mapActions({
      setNavigationVariant: 'nav/setNavigationVariant',
      fetchNavigationVariant: 'nav/fetchNavigationVariant',
      updateState: 'nav/updateState',
      toggleSubnav: 'nav/toggleSubnav',
      setAdditionalNav: 'nav/setAdditionalNav',
    }),

    manageNavState() {
      // This handling is needed to ensure that we don't try to loop over non existing values on desktop
      const desktopIsActive = window.innerWidth >= settings.mobileBreakpoint
      const currentTopic = desktopIsActive ? 0 : -1
      const currentBlock = desktopIsActive ? 0 : -1
      this.$store.commit('nav/setCurrentTopic', currentTopic)
      this.$store.commit('nav/setCurrentBlock', currentBlock)

      return (this.$store.state.nav.desktopNavigation = desktopIsActive)
    },

    handleKeydown(e) {
      if (e.keyCode === KEY_ESC) {
        this.setAdditionalNav('')
        this.toggleSubnav(false)
      }
    },

    setNavigationContents(identifier) {
      const navdata = window.NAVIGATION_DATA[identifier] || Object.values(window.NAVIGATION_DATA)[0]
      if (navdata) {
        // Update state with asynchronous data
        Object.keys(navdata.desktop).forEach(element => {
          this.updateState({
            key: element,
            value: navdata.desktop[element],
          })
        })

        Object.keys(navdata.mobile).forEach(element => {
          this.updateState({
            key: element,
            value: navdata.mobile[element],
          })
        })
      } else {
        this.$rollbar.error('No navigation data found for identifier: ' + identifier)
      }
    },
  },
}
On.initSmoothScroller()
</script>
